// userService.ts

import { Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserDTO } from '../components/user/user.model';
import { Role } from '../components/user/role.model';
import { Department } from '../components/user/department.model'; // Add department model
import { baseURL, getHeaders, VERSION } from '../constant/constant';
import { ResponseBase } from '../constant/response';
import { ResponseCommonForList } from '../dtos/ResponseDTOs';
import { IdName } from '../dtos/IdName';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  checkDuplicate(field: string, value: any) {
    throw new Error('Method not implemented.');
  }

  constructor(private http: HttpClient) { }

  create(userDTO: UserDTO): Observable<UserDTO> {
    return this.http.post<UserDTO>(`${baseURL}users/${VERSION}`, userDTO, getHeaders());
  }

  getAllUsers(userId: any, pageNo: number, pageSize: number, userIds?: number[], departmentIds?: number[], roleIds?: number[], employeeTypeIds?: number[], teamleadIds?: any): Observable<UserDTO[]> {
    const options = {
      headers: getHeaders().headers
    };
    let url = `${baseURL}users/${VERSION}/list?userId=${userId}&pageNo=${pageNo}&pageSize=${pageSize}`
    if (userIds && userIds.length > 0) {
      url = url.concat(`&userIds=${userIds}`)
    }
    if (departmentIds && departmentIds.length > 0) {
      url = url.concat(`&departmentIds=${departmentIds}`)
    }
    if (roleIds && roleIds.length > 0) {
      url = url.concat(`&roleIds=${roleIds}`)
    }
    if (employeeTypeIds && employeeTypeIds.length > 0) {
      url = url.concat(`&employeeTypeIds=${employeeTypeIds}`)
    }

     // IMPORTANT
  if (teamleadIds?.length) {
    url += `&teamleadIds=${teamleadIds}`;
  }
    return this.http.get<UserDTO[]>(url, options)
      .pipe(
        tap(),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getUserById(id: number): Observable<UserDTO> {
    return this.http.get<UserDTO>(`${baseURL}users/${VERSION}?id=${id}`, getHeaders());
  }

  update(userDTO: UserDTO): Observable<UserDTO> {
    return this.http.put<UserDTO>(`${baseURL}users/${VERSION}`, userDTO, getHeaders()).pipe(
      tap(),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  deleteById(id: number): Observable<UserDTO> {
    return this.http.delete<UserDTO>(`${baseURL}users/${VERSION}/delete?id=${id}`, getHeaders());
  }

  disabledById(id: number, flag: boolean) : Observable<ResponseBase<UserDTO>> {
    return this.http.get<ResponseBase<UserDTO>>(`${baseURL}users/${VERSION}/disable?id=${id}&flag=${flag}`, getHeaders());
  }

  softDeleteById(id: number, flag: boolean): Observable<ResponseBase<UserDTO>> {
    return this.http.get<ResponseBase<UserDTO>>(`${baseURL}users/${VERSION}/softDeleteUser?id=${id}&flag=${flag}`, getHeaders());
  }

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(`${baseURL}users/${VERSION}/roles`).pipe(
      tap(),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  getTeamleadsByDepartment(departmentId: number): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${baseURL}teamlead/${VERSION}/leads/department/${departmentId}`, getHeaders());
  }
  
  getDepartments(): Observable<Department[]> { // Add getDepartments method
    return this.http.get<Department[]>(`${baseURL}users/${VERSION}/departments`).pipe(
      tap(),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  resetUserPassword(id: number): Observable<UserDTO> {
    return this.http.get<UserDTO>(`${baseURL}users/${VERSION}/reset?id=${id}`, getHeaders());
  }

  getUserIdNameList(): Observable<ResponseCommonForList<IdName>> {
    return this.http.get<ResponseCommonForList<IdName>>(`${baseURL}users/${VERSION}/idName`);
  }

  getMembers(): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${baseURL}users/${VERSION}/members`);
  }

  bulkUpdateUsers(payload: any): Observable<any> {
  return this.http.put<any>(
    `${baseURL}users/${VERSION}/bulkUpdate`,
    payload,
    getHeaders()
  ).pipe(
    tap(),
    catchError(error => {
      return throwError(() => error);
    })
  );
}
}